module.exports = __webpack_public_path__ + "img/egg_flowers_happy.1037d3db.svg";